import * as React from "react";
import { Loading, LoadingTheme } from "./Loading";

/**
 * Use it to show loading for right side content;
 * Loading will always have fixed position to avoid spinner's 'jumping'
 */
export const ContentLoading = (props: Pick<ComponentProps<typeof Loading>, "withDelay">) => (
    <Loading {...props} theme={LoadingTheme.big} fixed={true} />
);
